module.exports = __webpack_public_path__ + "assets/img/YT.9d909e7d.svg";